module.exports = __webpack_public_path__ + "img/20230515162454_31205.31e57264.jpg";